(function ($) {
    var checkoutStepSelector = 'data-checkout-step';
    var checkoutStepInnerSelector = checkoutStepSelector + '-inner';
    var checkoutStepTriggerSelector = checkoutStepSelector + '-trigger';
    var checkoutStepProgressSelector = checkoutStepSelector + '-progress';
    var $checkoutSteps = $('[' + checkoutStepSelector + ']');
    var $checkoutStepTrigger = $('[' + checkoutStepTriggerSelector + ']');
    var $progressBarSteps = $('.progress-bar--step');
    var $mergeFormTrigger = $('[data-checkout-form-merge]');
    var progressBarActiveStep = 'progress-bar--step--active';

    if ($checkoutSteps.length > 0) {
        hideSections();
    }

    $checkoutStepTrigger.on('click', stepTriggerEvent);
    $mergeFormTrigger.on('click', mergeForm);

    function hideSections() {
        $checkoutSteps.addClass('form__container--disabled');
        $checkoutSteps.find('[' + checkoutStepInnerSelector + ']').addClass('collapse');
    }

    function showSection($checkoutStep) {
        $checkoutStep.removeClass('form__container--disabled');
        $checkoutStep.find('[' + checkoutStepInnerSelector + ']').addClass('in');
    }

    function updateProgressbar(step) {
        $progressBarSteps.removeClass(progressBarActiveStep);
        $progressBarSteps.eq(step - 1).addClass(progressBarActiveStep);
    }

    function stepValid($trigger) {
        var valid = true;
        var $triggerValidationGroup = $trigger.closest('[data-validated]');
        var $validationGroupErrors = $triggerValidationGroup.find('.has-error');

        if ($validationGroupErrors.length > 0) {
            valid = false;
        }

        return valid;
    }

    function stepTriggerEvent(event) {
        event.preventDefault();

        var $trigger = $(this);
        var step = $trigger.attr(checkoutStepTriggerSelector);
        var progress = $trigger.attr(checkoutStepProgressSelector);
        var $step = $('[' + checkoutStepSelector + '="' + step + '"]');
        var $stickyNav = $('[data-sticky-inner]');
        var navOffset = 0;

        if ($stickyNav.hasClass('sticky')) {
            navOffset = $stickyNav.height();
        }

        //force this to run after the validation script by using a timeout
        setTimeout(function () {
            if (stepValid($trigger)) {
                showSection($step);
                if (!isNaN(progress))
                    updateProgressbar(progress);
                //$trigger.attr('disabled', 'disabled');
                $('[data-checkout-step-trigger="' + step + '"]').attr('disabled', 'disabled');
                $('html, body').animate({ scrollTop: $step.first().parent().offset().top - navOffset }, 600);
            }
        }, 0);
        // Vat Calculation For DevliveryAddress - SBAU 2789
        var $addressListPostcode = $jq("#deliveryaddressfordisplay").find(".postal-code").text();
        var $postCode = $('#DeliveryAddress_PostCode').val();
        if (step == '3' && $addressListPostcode === "" && $postCode !== null && $postCode !== "") {
            refreshVatArea($postCode);
        }
    }

    function mergeForm() {
        $(this).closest('form').validator({
            disable: false
        });
    }

    function refreshVatArea($postCode) {
        var $url = '/api/sitecore/OnlineBasket/VatCalculationForDevliveryAddress';
        $.ajax({
            url: $url,
            type: 'post',
            contentType: 'application/json',
            data: JSON.stringify({
                postcode: $postCode
            })
        }).done(function (data) {
            $(".basket--summary").replaceWith(data);
        }).fail(function (error) {
            console.log(error.statusText);
        });
    }
})($jq);
